import EditSaveCancelButtons from '../../../../ui/edit-save-cancel-buttons'
import { useDispatch } from 'react-redux'
import { onChangePolicyInformation, setPolicyInformationType } from '../../../../../features/ebam/plicy-data-page/policy-information/policy-information.slice'
import { usePolicyActions } from '../../../../../hooks/actions/use-policy-actions';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import PolicyTabHeader from './policy-tab-header';
import PolicyContentHeaderAction from './policy-content-header-action';
import Input from '../../../../ui/input';
import { usePolicyDataState } from '../../../../../hooks/policy/use-policy-data-state';

export default function PolicySigningAddress() {

    const dispatch = useDispatch();
    const { 
        handleEditSigningAddress, 
        isLoadingUpdateSigningAddress, 
        handleEditDocumentCode,
        isLoadingUpdateDocumentCode,
        handleCancelEditPolicyAddressAndDocCode,
    } = usePolicyActions();
    const {
        isPIFullAddress,
        isPIDocumentCode,
        policyFullAddress,
        policyDocumentCode,
    } = usePolicyDataState()

    return (
        <section className="flex h-full min-h-full flex-col overflow-hidden rounded border border-gray-200 bg-white">
            <PolicyTabHeader
                title='Signing address and document code.'
                subTitle='Provide signing address and document code for data policy.'
            />
            <div className="py-3 px-4 space-y-4 lg:space-y-5 h-[100%]">
                <div className='rounded border border-gray-200'>
                    <div className="bg-[#eef6fc] border-b border-gray-300 px-3 py-3">
                        <div className="flex flex-row items-start justify-between gap-2 md:gap-4">
                            <PolicyContentHeaderAction
                                title='City/Municipality, Province'
                                subTitle='Enter the city/municipality and province.'
                            />
                            <EditSaveCancelButtons
                                isEditing={!isPIFullAddress}
                                onEdit={() => dispatch(setPolicyInformationType("cityMunicipalityProvince"))}
                                onCancel={handleCancelEditPolicyAddressAndDocCode}
                                onSave={handleEditSigningAddress}
                                isLoading={isLoadingUpdateSigningAddress}
                            />
                        </div>
                    </div>
                    <div className="px-3 py-3">
                        <div className="grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2">
                            <div>
                                <textarea
                                    name="pCityMunicipalityProvince"
                                    value={policyFullAddress}
                                    disabled={ !isPIFullAddress }
                                    className={`${defaultStyle} ${!policyFullAddress ? "" : customStyle} 
                                        ${!isPIFullAddress ? "cursor-not-allowed bg-gray-100" : ""
                                    } w-full resize-none`}
                                    onChange={(e) =>
                                        dispatch(onChangePolicyInformation({
                                            field: "cityMunicipalityProvince",
                                            value: e.target.value,
                                        }))
                                    }
                                    required
                                    rows={3}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='rounded border border-gray-200'>
                    <div className="bg-[#eef6fc] border-b border-gray-300 px-3 py-3">
                        <div className="flex flex-row items-start justify-between gap-2 md:gap-4">
                            <PolicyContentHeaderAction
                                title='Document Code'
                                subTitle='Enter document code for data policy.'
                            />
                            <EditSaveCancelButtons
                                isEditing={!isPIDocumentCode}
                                onEdit={() => dispatch(setPolicyInformationType("docCode"))}
                                onCancel={handleCancelEditPolicyAddressAndDocCode}
                                onSave={handleEditDocumentCode}
                                isLoading={isLoadingUpdateDocumentCode}
                            />
                        </div>
                    </div>
                    <div className="px-3 py-3">
                        <div className="grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2">
                            <div>
                                <Input
                                    type="text"
                                    name="pDocumentCode"
                                    value={policyDocumentCode}
                                    disabled={!isPIDocumentCode || isLoadingUpdateDocumentCode}
                                    isCustomStyle={true} 
                                    customCss={`${defaultStyle} ${!policyDocumentCode ? "" : customStyle} ${ !isPIDocumentCode ? "cursor-not-allowed bg-gray-100" : ""}`}
                                    onChange={(e) => dispatch(onChangePolicyInformation({ field: "docCode", value: e.target.value }))}
                                    required={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
